var render = function render(){var _vm=this,_c=_vm._self._c;return _c('grayBlackList',{attrs:{"shoptype":_vm.shoptype,"changeModule":_vm.changeModule}})
}
var staticRenderFns = []

export { render, staticRenderFns }